import * as React from 'react';
import {Atom} from '@packages/systems/wfdl';
import type {AtomRenderProps} from '@packages/systems/wfdl';
import {SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const BackgroundVideoPlayPauseButtonPlaying = Atom.createRender(
  ({
    attributes,
    classes,
    context,
    data,
    generateAttributes,
    renderChild,
  }: AtomRenderProps) => {
    const updatedAttributes =
      context.get('state') !== 'paused'
        ? attributes
        : attributes.set('hidden', 'true');
    return (
      <span {...generateAttributes(updatedAttributes, classes)}>
        {getChildren(data).map((child) => renderChild(child, context))}
      </span>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Play state',
  showEmpty: true,
  constraints: {
    pinToParent: true,
    descendants: [
      ...SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS,
      {is: 'BackgroundVideoWrapper', rule: 'Forbid'},
    ],
    ancestors: [{is: 'BackgroundVideoPlayPauseButton', rule: 'ExactlyOne'}],
  },
  render: BackgroundVideoPlayPauseButtonPlaying,
  fields: {children: TListOfElement},
});

export default config;
